import { asArray } from "@@/utilities/as-array";
import type { Permission } from "./permission";
import type { Scope } from "./scope";
import { scopeFactory } from "./scope-factory";

/**
 * Find a matchings cope for resource path segments and permissions
 */
function findMatchingScope(
    source: Scope[],
    segments: string | string[]
): Scope | undefined;
function findMatchingScope(
    source: Scope[],
    segments: string | string[],
    withPermission: Permission
): Scope | undefined;
function findMatchingScope(
    source: Scope[],
    segments: string | string[],
    withPermission: Permission[]
): Scope | undefined;
function findMatchingScope(
    source: Scope[],
    segments: string | string[],
    withPermission: Permission | Permission[]
): Scope | undefined;
function findMatchingScope(
    source: Scope[],
    segments: string | string[],
    withPermission?: Permission | Permission[]
): Scope | undefined {
    if (!source || !source.length) return undefined;
    const possibleScopes = asArray(scopeFactory(segments, withPermission));
    return source.find(scope => possibleScopes.includes(scope));
}

/**
 * Finds matchings scopes for resource path segments and permissions
 */
function findMatchingScopes(
    source: Scope[],
    segments: string | string[]
): Scope;

function findMatchingScopes(
    source: Scope[],
    segments: string | string[],
    withPermission: Permission
): Scope | undefined;
function findMatchingScopes(
    source: Scope[],
    segments: string | string[],

    withPermission: Permission[]
): Scope[];
function findMatchingScopes(
    source: Scope[],
    segments: string | string[],

    withPermission?: Permission | Permission[]
): Scope | undefined | Scope[] {
    if (!source || !source.length) return [];
    const possibleScopes = asArray(scopeFactory(segments, withPermission));

    if (Array.isArray(withPermission)) {
        const matches = source.filter(scope => possibleScopes.includes(scope));
        return matches;
    }

    return source.find(
        scope => scope === scopeFactory(segments, withPermission)
    );
}

export { findMatchingScope };
export { findMatchingScopes };
